// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const CirclePositioner = require('client-v2/common/components/circle-positioner')
const EmbeddedPlayer = require('client-v2/common/components/embedded-player')
const LazyImage = require('client-v2/common/components/lazy-image')
const Icon = require('client-v2/common/containers/icons/component')
const tag = require('client-v2/common/utils/hyperscript')
// Entry imports
const IntoHeader = require('client-v2/into-landing/containers/header/component-smart')
const IntoLinkModal = require('client-v2/into-landing/containers/link-modal/component-smart')

const bem = BemEntity('IntoContentProfileLayout')

function IntoContentProfileLayout(props) {
  const {
    // Flags
    isShareReferral,
    // Values
    iconId,
    likerCaption,
    likers,
    provider: { faviconURL, id, streamTitle },
    referredBy,
    related,
    url,
    // Callbacks
    onClick
  } = props
  return (
    tag('div', {
      className: bem.block({
        video: !!props.embedUrl
      })
    },
      tag('div', {
        className: bem.element('sidebar')
      },
        tag(IntoHeader, {
          className: bem.element('header')
        }),
        tag('div', {
          className: bem.element('details')
        },
          referredBy && tag('div', {
            className: bem.element('sharer')
          },
            tag(IntoUserAvatar, {
              iconId,
              user: referredBy,
              onClick
            }),
            tag('div', {
              className: bem.element('sharer-details')
            },
              tag('div', {
                className: bem.element('sharer-name')
              },
                referredBy['display_name']
              ),
              tag('div', {
                className: bem.element('sharer-caption')
              },
              isShareReferral && 'shared this with you'
              )
            )
          ),
          likers && tag([
            likerCaption,
            tag('div', {
              className: bem.element('likers')
            },
              likers.map(liker => (
                tag(IntoUserAvatar, {
                  key: liker.user_id,
                  iconId: 'heart',
                  user: liker,
                  onClick
                })
              ))
            )
          ]),
          tag('div', {
            className: bem.element('title')
          },
            props.title
          ),
          tag('div', {
            className: bem.element('provider')
          },
            tag('a', {
              className: bem.element('provider-info'),
              href: url,
              rel: 'external nofollow noopener',
              target: '_blank'
            },
              tag('div', {
                className: bem.element('source')
              },
                id
              ),
              tag('div', {
                className: bem.element('stream')
              },
                streamTitle
              )
            ),
            tag('a', {
              className: bem.element('provider-icon-wrapper'),
              href: url,
              rel: 'external nofollow noopener',
              target: '_blank'
            },
              tag(LazyImage, {
                className: bem.element('provider-icon'),
                rel: 'external nofollow noopener',
                target: '_blank',
                sources: [ faviconURL ]
              })
            )
          ),
          related.size > 0 && tag([
            tag('div', {
              className: bem.element('subheadline')
            },
              'Related topics'
            ),
            tag('div', {
              className: bem.element('related')
            },
              related.map(item => (
                tag('a', {
                  className: bem.element('related-item'),
                  href: `/topic/${item.slug}`
                }, 
                  tag('span', {
                    className: bem.element('related-hashtag')
                  },
                    ' # '
                  ),
                  item.name
                )
              ))
            )
          ])
        ),
        tag(IntoLinkModal, {
          className: bem.element('link-modal')
        })
      ),
      tag('div', {
        className: bem.element('content-wrapper')
      },
        tag(IntoCardContent, props)
      )
    )
  )
}

module.exports = IntoContentProfileLayout

function IntoUserAvatar(props) {
  const { iconId, user, onClick } = props
    // Temporary workaround while we have multiple paths for profile navigation
  return (
    tag('a', {
      className: bem.element('user'),
      href: `/${user.username}`,
      onClick: onClick
    },
      tag(LazyImage, {
        className: bem.element('user-image'),
        rel: 'external nofollow noopener',
        target: '_blank',
        sources: [ user['photo_url'] ]
      }),
      tag(CirclePositioner, {
        className: bem.element('badge-positioner')
      },
        tag(Icon, {
          className: bem.element('badge'),
          id: iconId
        })
      )
    )
  )
}

function IntoCardContent(props) {
  const { isRedditVideo, embedUrl, thumbnail, url } = props
  if (!embedUrl) {
    if (isRedditVideo) {
      return tag('a', {
        className: bem.element('reddit-video'),
        href: url,
        rel: 'external nofollow noopener',
        target: '_blank'
      },
        tag('img', {
          className: bem.element('image'),
          src: thumbnail
        })
      )
    }
    return tag('img', {
      className: bem.element('image'),
      src: thumbnail
    })
  }
  return (
    tag('div', {
      className: bem.element('embed-wrapper')
    },
      tag(LazyImage, {
        className: bem.element('embed-image'),
        rel: 'external nofollow noopener',
        target: '_blank',
        sources: [ thumbnail ]
      }),
      tag(EmbeddedPlayer, {
        className: bem.element('embed-player'),
        src: embedUrl,
        fallbackUrl: url
      })
    )
  )
}
